import { render } from "./NoteContent.vue?vue&type=template&id=8c4fd0ca&scoped=true"
import script from "./NoteContent.vue?vue&type=script&lang=js"
export * from "./NoteContent.vue?vue&type=script&lang=js"

import "./NoteContent.vue?vue&type=style&index=0&id=8c4fd0ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4fd0ca"]])

export default __exports__